import { LocalStorageKey } from '@ankr.com/auth';

export const resetIsMarketingAccepted = () =>
  localStorage.removeItem(LocalStorageKey.IsMarketingAccepted);
